import { Injectable } from '@angular/core';
import {SimpleUser, User} from "./user.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {Page} from "./api.service";
import {environment} from "../../environments/environment";
import {ProfileRequirements} from "./profile-requirements.service";
import { SimpleSubject } from './subject.service';
import { Enrollment } from './enrollment.service';

export type InviteStatus = 'ACTIVE' | 'COMPLETED' | 'DELETED' ;


export interface Invite {
  code: string;
  subject: SimpleSubject ;
  message: string ;
  createdBy?: SimpleUser ;
  requirements: ProfileRequirements ;
}


@Injectable({
  providedIn: 'root'
})
export class InviteService {

  constructor(private http: HttpClient) {

  }

  getInvite(code: string): Observable<Invite> {
    return this.http.get<Invite>(
      `${environment.apiHost}/invites/${code}`
    ) ;
  }

  acceptInvite(code: string): Observable<Enrollment> {
    return this.http.post<Enrollment>(
      `${environment.apiHost}/invites/${code}/acceptees`,
      {}
    )
  }

  getMyAcceptance(code: string): Observable<Enrollment> {

    return this.http.get<Enrollment>(
      `${environment.apiHost}/invites/${code}/acceptees/me`
    ) ;
  }

  getAcceptances(code: string, page?: number): Observable<Page<SimpleUser>> {

    let params = {
      page: (page) ? page : 0
    }

    return this.http.get<Page<SimpleUser>>(
      `${environment.apiHost}/invites/${code}/acceptees`,
      {params}
    ) ;
  }



}
